import React from 'react'
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"
import useAdminUsersInfo from "Pages/Admin/Users/@hooks/useInfo"
import { userPayload } from "Pages/Admin/Users/@signals"
import { BACKEND_APIS } from "@constants"

export default function UserDateFormatGeneration() {

	const {
		dateFormatGeneration,
		setDateFormatGenerationInfo
	} = useAdminUsersInfo(userPayload.peek()?.userConfig?.dateFormatGeneration, "dateFormatGeneration", "userConfig")


	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		value={dateFormatGeneration}
		onChange={e => setDateFormatGenerationInfo(e.target.value)}
		label="Generation Date Format"
		placeholder="Any format"
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/date/options/date_format`}
	/>
}